import React from 'react';
import classNameBind from 'classnames/bind';
import styles from './Header.module.css';

const bindClasses = classNameBind.bind(styles);

const Header = ({
  children,
  type,
  disabled,
  cutText,
}) => {
  switch (type) {
    case 'large':
      return (
        <h1
          className={bindClasses(type, { disabled, cutText })}
          data-ppuc-id="Header.large"
        >
          {children}
        </h1>
      );
    case 'small':
      return (
        <h3
          className={bindClasses(type, { disabled, cutText })}
          data-ppuc-id="Header.small"
        >
          {children}
        </h3>
      );
    default:
      return (
        <h2
          className={bindClasses(type, { disabled, cutText })}
          data-ppuc-id="Header.medium"
        >
          {children}
        </h2>
      );
  }
};

Header.defaultProps = {
  type: 'medium',
  disabled: false,
  cutText: true,
};

export default Header;
